import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  numeric: any;
  timestamptz: any;
  uuid: any;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "keywords" */
export type Keywords = {
  __typename?: 'keywords';
  id: Scalars['uuid'];
  occurrences: Scalars['numeric'];
  /** An object relationship */
  topic: Topics;
  topic_id: Scalars['uuid'];
  weight: Scalars['numeric'];
  word: Scalars['String'];
};

/** order by aggregate values of table "keywords" */
export type Keywords_Aggregate_Order_By = {
  avg?: InputMaybe<Keywords_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Keywords_Max_Order_By>;
  min?: InputMaybe<Keywords_Min_Order_By>;
  stddev?: InputMaybe<Keywords_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Keywords_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Keywords_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Keywords_Sum_Order_By>;
  var_pop?: InputMaybe<Keywords_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Keywords_Var_Samp_Order_By>;
  variance?: InputMaybe<Keywords_Variance_Order_By>;
};

/** order by avg() on columns of table "keywords" */
export type Keywords_Avg_Order_By = {
  occurrences?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "keywords". All fields are combined with a logical 'AND'. */
export type Keywords_Bool_Exp = {
  _and?: InputMaybe<Array<Keywords_Bool_Exp>>;
  _not?: InputMaybe<Keywords_Bool_Exp>;
  _or?: InputMaybe<Array<Keywords_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  occurrences?: InputMaybe<Numeric_Comparison_Exp>;
  topic?: InputMaybe<Topics_Bool_Exp>;
  topic_id?: InputMaybe<Uuid_Comparison_Exp>;
  weight?: InputMaybe<Numeric_Comparison_Exp>;
  word?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "keywords" */
export type Keywords_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  occurrences?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
  word?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "keywords" */
export type Keywords_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  occurrences?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
  word?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "keywords". */
export type Keywords_Order_By = {
  id?: InputMaybe<Order_By>;
  occurrences?: InputMaybe<Order_By>;
  topic?: InputMaybe<Topics_Order_By>;
  topic_id?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
  word?: InputMaybe<Order_By>;
};

/** select columns of table "keywords" */
export enum Keywords_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Occurrences = 'occurrences',
  /** column name */
  TopicId = 'topic_id',
  /** column name */
  Weight = 'weight',
  /** column name */
  Word = 'word'
}

/** order by stddev() on columns of table "keywords" */
export type Keywords_Stddev_Order_By = {
  occurrences?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "keywords" */
export type Keywords_Stddev_Pop_Order_By = {
  occurrences?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "keywords" */
export type Keywords_Stddev_Samp_Order_By = {
  occurrences?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "keywords" */
export type Keywords_Sum_Order_By = {
  occurrences?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "keywords" */
export type Keywords_Var_Pop_Order_By = {
  occurrences?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "keywords" */
export type Keywords_Var_Samp_Order_By = {
  occurrences?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "keywords" */
export type Keywords_Variance_Order_By = {
  occurrences?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** insert data into the table: "ratings" */
  insert_ratings?: Maybe<Ratings_Mutation_Response>;
  /** insert a single row into the table: "ratings" */
  insert_ratings_one?: Maybe<Ratings>;
};


/** mutation root */
export type Mutation_RootInsert_RatingsArgs = {
  objects: Array<Ratings_Insert_Input>;
  on_conflict?: InputMaybe<Ratings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ratings_OneArgs = {
  object: Ratings_Insert_Input;
  on_conflict?: InputMaybe<Ratings_On_Conflict>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

export type Query_Root = {
  __typename?: 'query_root';
  /** An array relationship */
  keywords: Array<Keywords>;
  /** fetch data from the table: "keywords" using primary key columns */
  keywords_by_pk?: Maybe<Keywords>;
  /** fetch data from the table: "ratings" */
  ratings: Array<Ratings>;
  /** fetch data from the table: "ratings" using primary key columns */
  ratings_by_pk?: Maybe<Ratings>;
  /** fetch data from the table: "response_topic_assignments" */
  response_topic_assignments: Array<Response_Topic_Assignments>;
  /** fetch aggregated fields from the table: "response_topic_assignments" */
  response_topic_assignments_aggregate: Response_Topic_Assignments_Aggregate;
  /** fetch data from the table: "response_topic_assignments" using primary key columns */
  response_topic_assignments_by_pk?: Maybe<Response_Topic_Assignments>;
  /** An array relationship */
  response_words: Array<Response_Words>;
  /** fetch data from the table: "response_words" using primary key columns */
  response_words_by_pk?: Maybe<Response_Words>;
  /** fetch data from the table: "responses" */
  responses: Array<Responses>;
  /** fetch data from the table: "responses" using primary key columns */
  responses_by_pk?: Maybe<Responses>;
  /** An array relationship */
  tasks: Array<Tasks>;
  /** An aggregate relationship */
  tasks_aggregate: Tasks_Aggregate;
  /** fetch data from the table: "tasks" using primary key columns */
  tasks_by_pk?: Maybe<Tasks>;
  /** fetch data from the table: "topics" */
  topics: Array<Topics>;
  /** fetch data from the table: "topics" using primary key columns */
  topics_by_pk?: Maybe<Topics>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
};


export type Query_RootKeywordsArgs = {
  distinct_on?: InputMaybe<Array<Keywords_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Keywords_Order_By>>;
  where?: InputMaybe<Keywords_Bool_Exp>;
};


export type Query_RootKeywords_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootRatingsArgs = {
  distinct_on?: InputMaybe<Array<Ratings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ratings_Order_By>>;
  where?: InputMaybe<Ratings_Bool_Exp>;
};


export type Query_RootRatings_By_PkArgs = {
  topic_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


export type Query_RootResponse_Topic_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Response_Topic_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Response_Topic_Assignments_Order_By>>;
  where?: InputMaybe<Response_Topic_Assignments_Bool_Exp>;
};


export type Query_RootResponse_Topic_Assignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Response_Topic_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Response_Topic_Assignments_Order_By>>;
  where?: InputMaybe<Response_Topic_Assignments_Bool_Exp>;
};


export type Query_RootResponse_Topic_Assignments_By_PkArgs = {
  response_id: Scalars['uuid'];
  topic_id: Scalars['uuid'];
};


export type Query_RootResponse_WordsArgs = {
  distinct_on?: InputMaybe<Array<Response_Words_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Response_Words_Order_By>>;
  where?: InputMaybe<Response_Words_Bool_Exp>;
};


export type Query_RootResponse_Words_By_PkArgs = {
  response_id: Scalars['uuid'];
  word: Scalars['String'];
};


export type Query_RootResponsesArgs = {
  distinct_on?: InputMaybe<Array<Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Responses_Order_By>>;
  where?: InputMaybe<Responses_Bool_Exp>;
};


export type Query_RootResponses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTasksArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


export type Query_RootTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


export type Query_RootTasks_By_PkArgs = {
  topic_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


export type Query_RootTopicsArgs = {
  distinct_on?: InputMaybe<Array<Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Topics_Order_By>>;
  where?: InputMaybe<Topics_Bool_Exp>;
};


export type Query_RootTopics_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['uuid'];
};

/** columns and relationships of "ratings" */
export type Ratings = {
  __typename?: 'ratings';
  created_at: Scalars['timestamptz'];
  match_rating: Scalars['Int'];
  responses_notes: Scalars['String'];
  responses_rating: Scalars['Int'];
  /** An object relationship */
  task?: Maybe<Tasks>;
  topic_id: Scalars['uuid'];
  topic_name: Scalars['String'];
  user_id: Scalars['uuid'];
  wordcloud_notes: Scalars['String'];
  wordcloud_rating: Scalars['Int'];
};

/** Boolean expression to filter rows from the table "ratings". All fields are combined with a logical 'AND'. */
export type Ratings_Bool_Exp = {
  _and?: InputMaybe<Array<Ratings_Bool_Exp>>;
  _not?: InputMaybe<Ratings_Bool_Exp>;
  _or?: InputMaybe<Array<Ratings_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  match_rating?: InputMaybe<Int_Comparison_Exp>;
  responses_notes?: InputMaybe<String_Comparison_Exp>;
  responses_rating?: InputMaybe<Int_Comparison_Exp>;
  task?: InputMaybe<Tasks_Bool_Exp>;
  topic_id?: InputMaybe<Uuid_Comparison_Exp>;
  topic_name?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  wordcloud_notes?: InputMaybe<String_Comparison_Exp>;
  wordcloud_rating?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "ratings" */
export enum Ratings_Constraint {
  /** unique or primary key constraint on columns "topic_id", "user_id" */
  RatingsPkey = 'ratings_pkey'
}

/** input type for inserting data into table "ratings" */
export type Ratings_Insert_Input = {
  match_rating?: InputMaybe<Scalars['Int']>;
  responses_notes?: InputMaybe<Scalars['String']>;
  responses_rating?: InputMaybe<Scalars['Int']>;
  topic_id?: InputMaybe<Scalars['uuid']>;
  topic_name?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
  wordcloud_notes?: InputMaybe<Scalars['String']>;
  wordcloud_rating?: InputMaybe<Scalars['Int']>;
};

/** response of any mutation on the table "ratings" */
export type Ratings_Mutation_Response = {
  __typename?: 'ratings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ratings>;
};

/** on_conflict condition type for table "ratings" */
export type Ratings_On_Conflict = {
  constraint: Ratings_Constraint;
  update_columns?: Array<Ratings_Update_Column>;
  where?: InputMaybe<Ratings_Bool_Exp>;
};

/** Ordering options when selecting data from "ratings". */
export type Ratings_Order_By = {
  created_at?: InputMaybe<Order_By>;
  match_rating?: InputMaybe<Order_By>;
  responses_notes?: InputMaybe<Order_By>;
  responses_rating?: InputMaybe<Order_By>;
  task?: InputMaybe<Tasks_Order_By>;
  topic_id?: InputMaybe<Order_By>;
  topic_name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  wordcloud_notes?: InputMaybe<Order_By>;
  wordcloud_rating?: InputMaybe<Order_By>;
};

/** select columns of table "ratings" */
export enum Ratings_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  MatchRating = 'match_rating',
  /** column name */
  ResponsesNotes = 'responses_notes',
  /** column name */
  ResponsesRating = 'responses_rating',
  /** column name */
  TopicId = 'topic_id',
  /** column name */
  TopicName = 'topic_name',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WordcloudNotes = 'wordcloud_notes',
  /** column name */
  WordcloudRating = 'wordcloud_rating'
}

/** placeholder for update columns of table "ratings" (current role has no relevant permissions) */
export enum Ratings_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "response_topic_assignments" */
export type Response_Topic_Assignments = {
  __typename?: 'response_topic_assignments';
  /** An object relationship */
  response: Responses;
  response_id: Scalars['uuid'];
  score: Scalars['numeric'];
  /** An object relationship */
  topic: Topics;
  topic_id: Scalars['uuid'];
};

/** aggregated selection of "response_topic_assignments" */
export type Response_Topic_Assignments_Aggregate = {
  __typename?: 'response_topic_assignments_aggregate';
  aggregate?: Maybe<Response_Topic_Assignments_Aggregate_Fields>;
  nodes: Array<Response_Topic_Assignments>;
};

/** aggregate fields of "response_topic_assignments" */
export type Response_Topic_Assignments_Aggregate_Fields = {
  __typename?: 'response_topic_assignments_aggregate_fields';
  avg?: Maybe<Response_Topic_Assignments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Response_Topic_Assignments_Max_Fields>;
  min?: Maybe<Response_Topic_Assignments_Min_Fields>;
  stddev?: Maybe<Response_Topic_Assignments_Stddev_Fields>;
  stddev_pop?: Maybe<Response_Topic_Assignments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Response_Topic_Assignments_Stddev_Samp_Fields>;
  sum?: Maybe<Response_Topic_Assignments_Sum_Fields>;
  var_pop?: Maybe<Response_Topic_Assignments_Var_Pop_Fields>;
  var_samp?: Maybe<Response_Topic_Assignments_Var_Samp_Fields>;
  variance?: Maybe<Response_Topic_Assignments_Variance_Fields>;
};


/** aggregate fields of "response_topic_assignments" */
export type Response_Topic_Assignments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Response_Topic_Assignments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "response_topic_assignments" */
export type Response_Topic_Assignments_Aggregate_Order_By = {
  avg?: InputMaybe<Response_Topic_Assignments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Response_Topic_Assignments_Max_Order_By>;
  min?: InputMaybe<Response_Topic_Assignments_Min_Order_By>;
  stddev?: InputMaybe<Response_Topic_Assignments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Response_Topic_Assignments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Response_Topic_Assignments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Response_Topic_Assignments_Sum_Order_By>;
  var_pop?: InputMaybe<Response_Topic_Assignments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Response_Topic_Assignments_Var_Samp_Order_By>;
  variance?: InputMaybe<Response_Topic_Assignments_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Response_Topic_Assignments_Avg_Fields = {
  __typename?: 'response_topic_assignments_avg_fields';
  score?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "response_topic_assignments" */
export type Response_Topic_Assignments_Avg_Order_By = {
  score?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "response_topic_assignments". All fields are combined with a logical 'AND'. */
export type Response_Topic_Assignments_Bool_Exp = {
  _and?: InputMaybe<Array<Response_Topic_Assignments_Bool_Exp>>;
  _not?: InputMaybe<Response_Topic_Assignments_Bool_Exp>;
  _or?: InputMaybe<Array<Response_Topic_Assignments_Bool_Exp>>;
  response?: InputMaybe<Responses_Bool_Exp>;
  response_id?: InputMaybe<Uuid_Comparison_Exp>;
  score?: InputMaybe<Numeric_Comparison_Exp>;
  topic?: InputMaybe<Topics_Bool_Exp>;
  topic_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Response_Topic_Assignments_Max_Fields = {
  __typename?: 'response_topic_assignments_max_fields';
  response_id?: Maybe<Scalars['uuid']>;
  score?: Maybe<Scalars['numeric']>;
  topic_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "response_topic_assignments" */
export type Response_Topic_Assignments_Max_Order_By = {
  response_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Response_Topic_Assignments_Min_Fields = {
  __typename?: 'response_topic_assignments_min_fields';
  response_id?: Maybe<Scalars['uuid']>;
  score?: Maybe<Scalars['numeric']>;
  topic_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "response_topic_assignments" */
export type Response_Topic_Assignments_Min_Order_By = {
  response_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "response_topic_assignments". */
export type Response_Topic_Assignments_Order_By = {
  response?: InputMaybe<Responses_Order_By>;
  response_id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  topic?: InputMaybe<Topics_Order_By>;
  topic_id?: InputMaybe<Order_By>;
};

/** select columns of table "response_topic_assignments" */
export enum Response_Topic_Assignments_Select_Column {
  /** column name */
  ResponseId = 'response_id',
  /** column name */
  Score = 'score',
  /** column name */
  TopicId = 'topic_id'
}

/** aggregate stddev on columns */
export type Response_Topic_Assignments_Stddev_Fields = {
  __typename?: 'response_topic_assignments_stddev_fields';
  score?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "response_topic_assignments" */
export type Response_Topic_Assignments_Stddev_Order_By = {
  score?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Response_Topic_Assignments_Stddev_Pop_Fields = {
  __typename?: 'response_topic_assignments_stddev_pop_fields';
  score?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "response_topic_assignments" */
export type Response_Topic_Assignments_Stddev_Pop_Order_By = {
  score?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Response_Topic_Assignments_Stddev_Samp_Fields = {
  __typename?: 'response_topic_assignments_stddev_samp_fields';
  score?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "response_topic_assignments" */
export type Response_Topic_Assignments_Stddev_Samp_Order_By = {
  score?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Response_Topic_Assignments_Sum_Fields = {
  __typename?: 'response_topic_assignments_sum_fields';
  score?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "response_topic_assignments" */
export type Response_Topic_Assignments_Sum_Order_By = {
  score?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Response_Topic_Assignments_Var_Pop_Fields = {
  __typename?: 'response_topic_assignments_var_pop_fields';
  score?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "response_topic_assignments" */
export type Response_Topic_Assignments_Var_Pop_Order_By = {
  score?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Response_Topic_Assignments_Var_Samp_Fields = {
  __typename?: 'response_topic_assignments_var_samp_fields';
  score?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "response_topic_assignments" */
export type Response_Topic_Assignments_Var_Samp_Order_By = {
  score?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Response_Topic_Assignments_Variance_Fields = {
  __typename?: 'response_topic_assignments_variance_fields';
  score?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "response_topic_assignments" */
export type Response_Topic_Assignments_Variance_Order_By = {
  score?: InputMaybe<Order_By>;
};

/** columns and relationships of "response_words" */
export type Response_Words = {
  __typename?: 'response_words';
  /** An object relationship */
  response: Responses;
  response_id: Scalars['uuid'];
  word: Scalars['String'];
};

/** order by aggregate values of table "response_words" */
export type Response_Words_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Response_Words_Max_Order_By>;
  min?: InputMaybe<Response_Words_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "response_words". All fields are combined with a logical 'AND'. */
export type Response_Words_Bool_Exp = {
  _and?: InputMaybe<Array<Response_Words_Bool_Exp>>;
  _not?: InputMaybe<Response_Words_Bool_Exp>;
  _or?: InputMaybe<Array<Response_Words_Bool_Exp>>;
  response?: InputMaybe<Responses_Bool_Exp>;
  response_id?: InputMaybe<Uuid_Comparison_Exp>;
  word?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "response_words" */
export type Response_Words_Max_Order_By = {
  response_id?: InputMaybe<Order_By>;
  word?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "response_words" */
export type Response_Words_Min_Order_By = {
  response_id?: InputMaybe<Order_By>;
  word?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "response_words". */
export type Response_Words_Order_By = {
  response?: InputMaybe<Responses_Order_By>;
  response_id?: InputMaybe<Order_By>;
  word?: InputMaybe<Order_By>;
};

/** select columns of table "response_words" */
export enum Response_Words_Select_Column {
  /** column name */
  ResponseId = 'response_id',
  /** column name */
  Word = 'word'
}

/** columns and relationships of "responses" */
export type Responses = {
  __typename?: 'responses';
  content: Scalars['String'];
  id: Scalars['uuid'];
  /** An array relationship */
  response_words: Array<Response_Words>;
  /** An array relationship */
  topic_assignments: Array<Response_Topic_Assignments>;
  /** An aggregate relationship */
  topic_assignments_aggregate: Response_Topic_Assignments_Aggregate;
};


/** columns and relationships of "responses" */
export type ResponsesResponse_WordsArgs = {
  distinct_on?: InputMaybe<Array<Response_Words_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Response_Words_Order_By>>;
  where?: InputMaybe<Response_Words_Bool_Exp>;
};


/** columns and relationships of "responses" */
export type ResponsesTopic_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Response_Topic_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Response_Topic_Assignments_Order_By>>;
  where?: InputMaybe<Response_Topic_Assignments_Bool_Exp>;
};


/** columns and relationships of "responses" */
export type ResponsesTopic_Assignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Response_Topic_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Response_Topic_Assignments_Order_By>>;
  where?: InputMaybe<Response_Topic_Assignments_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "responses". All fields are combined with a logical 'AND'. */
export type Responses_Bool_Exp = {
  _and?: InputMaybe<Array<Responses_Bool_Exp>>;
  _not?: InputMaybe<Responses_Bool_Exp>;
  _or?: InputMaybe<Array<Responses_Bool_Exp>>;
  content?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  response_words?: InputMaybe<Response_Words_Bool_Exp>;
  topic_assignments?: InputMaybe<Response_Topic_Assignments_Bool_Exp>;
};

/** Ordering options when selecting data from "responses". */
export type Responses_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  response_words_aggregate?: InputMaybe<Response_Words_Aggregate_Order_By>;
  topic_assignments_aggregate?: InputMaybe<Response_Topic_Assignments_Aggregate_Order_By>;
};

/** select columns of table "responses" */
export enum Responses_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id'
}

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** An array relationship */
  keywords: Array<Keywords>;
  /** fetch data from the table: "keywords" using primary key columns */
  keywords_by_pk?: Maybe<Keywords>;
  /** fetch data from the table: "ratings" */
  ratings: Array<Ratings>;
  /** fetch data from the table: "ratings" using primary key columns */
  ratings_by_pk?: Maybe<Ratings>;
  /** fetch data from the table: "response_topic_assignments" */
  response_topic_assignments: Array<Response_Topic_Assignments>;
  /** fetch aggregated fields from the table: "response_topic_assignments" */
  response_topic_assignments_aggregate: Response_Topic_Assignments_Aggregate;
  /** fetch data from the table: "response_topic_assignments" using primary key columns */
  response_topic_assignments_by_pk?: Maybe<Response_Topic_Assignments>;
  /** An array relationship */
  response_words: Array<Response_Words>;
  /** fetch data from the table: "response_words" using primary key columns */
  response_words_by_pk?: Maybe<Response_Words>;
  /** fetch data from the table: "responses" */
  responses: Array<Responses>;
  /** fetch data from the table: "responses" using primary key columns */
  responses_by_pk?: Maybe<Responses>;
  /** An array relationship */
  tasks: Array<Tasks>;
  /** An aggregate relationship */
  tasks_aggregate: Tasks_Aggregate;
  /** fetch data from the table: "tasks" using primary key columns */
  tasks_by_pk?: Maybe<Tasks>;
  /** fetch data from the table: "topics" */
  topics: Array<Topics>;
  /** fetch data from the table: "topics" using primary key columns */
  topics_by_pk?: Maybe<Topics>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
};


export type Subscription_RootKeywordsArgs = {
  distinct_on?: InputMaybe<Array<Keywords_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Keywords_Order_By>>;
  where?: InputMaybe<Keywords_Bool_Exp>;
};


export type Subscription_RootKeywords_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRatingsArgs = {
  distinct_on?: InputMaybe<Array<Ratings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ratings_Order_By>>;
  where?: InputMaybe<Ratings_Bool_Exp>;
};


export type Subscription_RootRatings_By_PkArgs = {
  topic_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


export type Subscription_RootResponse_Topic_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Response_Topic_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Response_Topic_Assignments_Order_By>>;
  where?: InputMaybe<Response_Topic_Assignments_Bool_Exp>;
};


export type Subscription_RootResponse_Topic_Assignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Response_Topic_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Response_Topic_Assignments_Order_By>>;
  where?: InputMaybe<Response_Topic_Assignments_Bool_Exp>;
};


export type Subscription_RootResponse_Topic_Assignments_By_PkArgs = {
  response_id: Scalars['uuid'];
  topic_id: Scalars['uuid'];
};


export type Subscription_RootResponse_WordsArgs = {
  distinct_on?: InputMaybe<Array<Response_Words_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Response_Words_Order_By>>;
  where?: InputMaybe<Response_Words_Bool_Exp>;
};


export type Subscription_RootResponse_Words_By_PkArgs = {
  response_id: Scalars['uuid'];
  word: Scalars['String'];
};


export type Subscription_RootResponsesArgs = {
  distinct_on?: InputMaybe<Array<Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Responses_Order_By>>;
  where?: InputMaybe<Responses_Bool_Exp>;
};


export type Subscription_RootResponses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTasksArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


export type Subscription_RootTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


export type Subscription_RootTasks_By_PkArgs = {
  topic_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


export type Subscription_RootTopicsArgs = {
  distinct_on?: InputMaybe<Array<Topics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Topics_Order_By>>;
  where?: InputMaybe<Topics_Bool_Exp>;
};


export type Subscription_RootTopics_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['uuid'];
};

/** columns and relationships of "tasks" */
export type Tasks = {
  __typename?: 'tasks';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  rating?: Maybe<Ratings>;
  /** An object relationship */
  topic: Topics;
  topic_id: Scalars['uuid'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "tasks" */
export type Tasks_Aggregate = {
  __typename?: 'tasks_aggregate';
  aggregate?: Maybe<Tasks_Aggregate_Fields>;
  nodes: Array<Tasks>;
};

/** aggregate fields of "tasks" */
export type Tasks_Aggregate_Fields = {
  __typename?: 'tasks_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Tasks_Max_Fields>;
  min?: Maybe<Tasks_Min_Fields>;
};


/** aggregate fields of "tasks" */
export type Tasks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tasks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tasks" */
export type Tasks_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tasks_Max_Order_By>;
  min?: InputMaybe<Tasks_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "tasks". All fields are combined with a logical 'AND'. */
export type Tasks_Bool_Exp = {
  _and?: InputMaybe<Array<Tasks_Bool_Exp>>;
  _not?: InputMaybe<Tasks_Bool_Exp>;
  _or?: InputMaybe<Array<Tasks_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  rating?: InputMaybe<Ratings_Bool_Exp>;
  topic?: InputMaybe<Topics_Bool_Exp>;
  topic_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Tasks_Max_Fields = {
  __typename?: 'tasks_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  topic_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "tasks" */
export type Tasks_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tasks_Min_Fields = {
  __typename?: 'tasks_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  topic_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "tasks" */
export type Tasks_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tasks". */
export type Tasks_Order_By = {
  created_at?: InputMaybe<Order_By>;
  rating?: InputMaybe<Ratings_Order_By>;
  topic?: InputMaybe<Topics_Order_By>;
  topic_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "tasks" */
export enum Tasks_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  TopicId = 'topic_id',
  /** column name */
  UserId = 'user_id'
}

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "topics" */
export type Topics = {
  __typename?: 'topics';
  id: Scalars['uuid'];
  /** An array relationship */
  keywords: Array<Keywords>;
  /** An array relationship */
  response_assignments: Array<Response_Topic_Assignments>;
  /** An aggregate relationship */
  response_assignments_aggregate: Response_Topic_Assignments_Aggregate;
  /** An array relationship */
  tasks: Array<Tasks>;
  /** An aggregate relationship */
  tasks_aggregate: Tasks_Aggregate;
  topic_model_id: Scalars['uuid'];
};


/** columns and relationships of "topics" */
export type TopicsKeywordsArgs = {
  distinct_on?: InputMaybe<Array<Keywords_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Keywords_Order_By>>;
  where?: InputMaybe<Keywords_Bool_Exp>;
};


/** columns and relationships of "topics" */
export type TopicsResponse_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Response_Topic_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Response_Topic_Assignments_Order_By>>;
  where?: InputMaybe<Response_Topic_Assignments_Bool_Exp>;
};


/** columns and relationships of "topics" */
export type TopicsResponse_Assignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Response_Topic_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Response_Topic_Assignments_Order_By>>;
  where?: InputMaybe<Response_Topic_Assignments_Bool_Exp>;
};


/** columns and relationships of "topics" */
export type TopicsTasksArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


/** columns and relationships of "topics" */
export type TopicsTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "topics". All fields are combined with a logical 'AND'. */
export type Topics_Bool_Exp = {
  _and?: InputMaybe<Array<Topics_Bool_Exp>>;
  _not?: InputMaybe<Topics_Bool_Exp>;
  _or?: InputMaybe<Array<Topics_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  keywords?: InputMaybe<Keywords_Bool_Exp>;
  response_assignments?: InputMaybe<Response_Topic_Assignments_Bool_Exp>;
  tasks?: InputMaybe<Tasks_Bool_Exp>;
  topic_model_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "topics". */
export type Topics_Order_By = {
  id?: InputMaybe<Order_By>;
  keywords_aggregate?: InputMaybe<Keywords_Aggregate_Order_By>;
  response_assignments_aggregate?: InputMaybe<Response_Topic_Assignments_Aggregate_Order_By>;
  tasks_aggregate?: InputMaybe<Tasks_Aggregate_Order_By>;
  topic_model_id?: InputMaybe<Order_By>;
};

/** select columns of table "topics" */
export enum Topics_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  TopicModelId = 'topic_model_id'
}

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  tasks: Array<Tasks>;
  /** An aggregate relationship */
  tasks_aggregate: Tasks_Aggregate;
};


/** columns and relationships of "users" */
export type UsersTasksArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  tasks?: InputMaybe<Tasks_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  tasks_aggregate?: InputMaybe<Tasks_Aggregate_Order_By>;
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

export type NextTaskQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type NextTaskQuery = { __typename?: 'query_root', tasks: Array<{ __typename?: 'tasks', user: { __typename?: 'users', id: any }, topic: { __typename?: 'topics', id: any, keywords: Array<{ __typename?: 'keywords', word: string, weight: any, occurrences: any }> } }> };

export type SaveRatingMutationVariables = Exact<{
  user_id: Scalars['uuid'];
  topic_id: Scalars['uuid'];
  wordcloud_rating: Scalars['Int'];
  topic_name: Scalars['String'];
  wordcloud_notes: Scalars['String'];
  responses_rating: Scalars['Int'];
  match_rating: Scalars['Int'];
  responses_notes: Scalars['String'];
}>;


export type SaveRatingMutation = { __typename?: 'mutation_root', insert_ratings_one?: { __typename: 'ratings' } | null };

export type TaskProgressQueryVariables = Exact<{ [key: string]: never; }>;


export type TaskProgressQuery = { __typename?: 'query_root', total: { __typename?: 'tasks_aggregate', aggregate?: { __typename?: 'tasks_aggregate_fields', count: number } | null }, done: { __typename?: 'tasks_aggregate', aggregate?: { __typename?: 'tasks_aggregate_fields', count: number } | null } };

export type TopicResponsesQueryVariables = Exact<{
  topic_id: Scalars['uuid'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  where?: InputMaybe<Response_Topic_Assignments_Bool_Exp>;
}>;


export type TopicResponsesQuery = { __typename?: 'query_root', topics_by_pk?: { __typename?: 'topics', response_assignments_aggregate: { __typename?: 'response_topic_assignments_aggregate', aggregate?: { __typename?: 'response_topic_assignments_aggregate_fields', totalCount: number } | null }, response_assignments: Array<{ __typename?: 'response_topic_assignments', score: any, response: { __typename?: 'responses', id: any, content: string } }> } | null };


export const NextTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"nextTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rating"},"value":{"kind":"ObjectValue","fields":[]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"60"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"weight"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"word"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"occurrences"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NextTaskQuery, NextTaskQueryVariables>;
export const SaveRatingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"saveRating"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"topic_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordcloud_rating"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"topic_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordcloud_notes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responses_rating"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"match_rating"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responses_notes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_ratings_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"topic_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"topic_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"wordcloud_rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordcloud_rating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"topic_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"topic_name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"wordcloud_notes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordcloud_notes"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"responses_rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responses_rating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"match_rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"match_rating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"responses_notes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responses_notes"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<SaveRatingMutation, SaveRatingMutationVariables>;
export const TaskProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"taskProgress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"total"},"name":{"kind":"Name","value":"tasks_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"done"},"name":{"kind":"Name","value":"tasks_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rating"},"value":{"kind":"ObjectValue","fields":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<TaskProgressQuery, TaskProgressQueryVariables>;
export const TopicResponsesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"topicResponses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"topic_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"response_topic_assignments_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topics_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"topic_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"response_assignments_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"totalCount"},"name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"response_assignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"score"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"response"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TopicResponsesQuery, TopicResponsesQueryVariables>;